import { Header, InventoryCollectionForm } from "@src/components"
import { ar } from "@src/i18n/ar"

export default function CreateInventoryCollections() {
  return (
    <>
      <Header title={ar.createInventoryCollections} />
      <InventoryCollectionForm />
    </>
  )
}
